import React, { useMemo } from 'react';

import { Container, Box, Divider } from '@mui/material';
import { CustomerExperienceCard } from 'views/common/components';
import ERPagination from 'views/common/components/UI/ERPagination';
import { ReviewSummarySection } from 'views/information-module/ReviewsView/components';
import PATHS from 'lib/navigation/paths';
import dayjs from 'dayjs';
import { TOUR_TYPES } from 'lib/utils/CONSTANTS';
import StyledBox from 'views/information-module/ReviewsView/components/CustomerExperienceSection/CustomerExperienceSection.styles';
import { useTranslation } from 'next-i18next';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

const CustomerExperienceSection = (props) => {
  const { customerExperience, handlePaginationClick } = props;
  const { t } = useTranslation('fe_er_reviews_page');
  const appNavigator = useAppNavigator();

  const pagingData = useMemo(
    () => ({
      active_page: customerExperience.pagination?.page,
      pages_count: customerExperience.pagination?.pages_count,
    }),
    [customerExperience.pagination],
  );
  const getTourPageUrl = (tour) => {
    let url;
    switch (tour?.tour_type?.identifier) {
      case TOUR_TYPES.GUIDED:
        return PATHS.guidedTour(tour?.slug).url;
      case TOUR_TYPES.SELF_DRIVE:
        url = PATHS.selfDriveTour(tour?.slug).url;
        break;
      case TOUR_TYPES.GUIDED_OFFROAD:
        url = PATHS.guidedOffroadTour.slug(tour?.slug).url;
        break;
      default:
        break;
    }
    return url;
  };

  return (
    <StyledBox mb={10}>
      <Container maxWidth="xl">
        <Box pb={3} className="showDESKTOP">
          <Divider light />
        </Box>
      </Container>
      <Box py={5} className="RVSummarySection">
        <Container maxWidth="xl">
          <ReviewSummarySection
            totalRatings={customerExperience.metrics.retail_surveys_submitted}
            experienceRating={customerExperience.metrics.aggregate_rating}
            reviewsSummarymetrics={[
              {
                label: t('fe_er_reviews_page:overall_experience'),
                value: customerExperience.metrics.overall_experience_percentage,
              },
              {
                label: t('fe_er_reviews_page:recommend_to_friends'),
                value:
                  customerExperience.metrics.recommend_to_friends_percentage,
              },
              {
                label: t('fe_er_reviews_page:would_rent_again'),
                value: customerExperience.metrics.rent_again_percentage,
              },
            ]}
          />
        </Container>
      </Box>

      <Container maxWidth="xl" className="RSExperienceCardWrapper">
        <Box pb={5} className="showDESKTOP">
          <Divider light />
        </Box>
        {customerExperience.vehicle_reservation_feedbacks.map((feedback) => (
          <CustomerExperienceCard
            key={feedback.id}
            reviewId={feedback.id}
            reviewDate={dayjs(feedback.created_at)
              .locale(mapNamedLocaleToLocale[appNavigator.locale].toLowerCase())
              .format('MMMM D, YYYY HH:mm a')}
            userName={`${
              feedback.reviewer?.first_name
            } ${feedback.reviewer?.last_name?.charAt(0)}.`}
            avatarDisplayChars={`${feedback.reviewer?.first_name?.charAt(
              0,
            )} ${feedback.reviewer?.last_name?.charAt(0)}`}
            pickupLocation={{
              name: feedback.location?.name,
              url: PATHS.locationSlug(feedback.location?.slug).url,
            }}
            bikeModel={{
              name: feedback.vehicle_model?.name,
              url: PATHS.vehicleModel.index(
                feedback.location?.slug,
                feedback.vehicle_model?.vehicle_make?.slug,
                feedback.vehicle_model?.slug,
              ).url,
              translateUrl: false,
            }}
            tourPage={{
              name: feedback.tour?.name,
              url: getTourPageUrl(feedback?.tour),
            }}
            userImage={{
              src: feedback.reviewer?.avatar?.small_url,
              alt: 'user-avatar',
            }}
            value={parseFloat(feedback.average_rating).toFixed(1)}
          />
        ))}
        {(customerExperience.vehicle_reservation_feedbacks.length > 2
          || pagingData.pages_count > 1) && (
          <Box className="RSPaggingContiner">
            <ERPagination
              data={pagingData}
              handleChange={handlePaginationClick}
            />
          </Box>
        )}
      </Container>
    </StyledBox>
  );
};
export { CustomerExperienceSection };
